import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 10 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 20\" id=\"icon-chevron-right\"><path fill=\"currentColor\" d=\"M8.555 10L0 1.466V0l10 10L0 20v-1.465z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol